import { Component, Output, EventEmitter, Input } from '@angular/core';
import {
  ReportRecord,
  ReportInfo,
  ReportOptions,
  RecordUpdateEmission,
  TemplateProjectionMap,
} from '../../models/report.model';
import { RawColumn } from '../../models/template.model';

@Component({
  selector: 'rep-data-view',
  templateUrl: './data-view.component.html',
  standalone: false,
})
export class DataViewComponent {
  @Input() reportData: ReportInfo;
  @Input() reportOptions: ReportOptions;
  @Input() displayedColumns: RawColumn[];
  @Input() defaultColumns: RawColumn[];
  @Input() reportLocale: number;
  @Input() templateProjectionMap: TemplateProjectionMap;
  @Input() isUKFeaturesEnabled: boolean;

  @Output() removeRecord: EventEmitter<ReportRecord> = new EventEmitter<ReportRecord>();
  @Output() reportReordered: EventEmitter<ReportRecord[]> = new EventEmitter<ReportRecord[]>();
  @Output() customizeColumns: EventEmitter<string> = new EventEmitter<string>();
  @Output() reportUpdateClick: EventEmitter<RecordUpdateEmission> = new EventEmitter<RecordUpdateEmission>();
  @Output() reorderReportColumns: EventEmitter<number[]> = new EventEmitter<number[]>();

  removeRecordFromReport(reportItem) {
    const recordId = reportItem.recordId ? reportItem.recordId : reportItem.data.recordId;
    this.removeRecord.emit({ ...reportItem, recordId });
  }
}
